module.exports = __webpack_public_path__ + "static/Unilever-DSEP-ClassroomActivity-Virtual-2.1-WhatsYourFunction[Port]-73a00fdcecdb8ee1e879214e261078be.pdf";